exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".line_extr_line,.line_wi_100{width:100%;display:inline-block}.line_extr_line{position:relative}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./app/views/masters/masters.css
// module id = 239
// module chunks = 0